import { jsxs as c, jsx as h } from "react/jsx-runtime";
import { E as t, S as p } from "./icons.types-0722eef5.js";
function m({ title: a, titleId: e, size: l, width: d, height: s, extended: n = !1, ...v }) {
  const i = n ? t : p, o = l ? i[l] : d || i[n ? "s" : "l"], r = l ? i[l] : s || i[n ? "s" : "l"];
  return /* @__PURE__ */ c(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: o,
      height: r,
      "aria-labelledby": e,
      ...v,
      children: [
        a ? /* @__PURE__ */ h("title", { id: e, children: a }) : null,
        /* @__PURE__ */ c(
          "g",
          {
            fill: "#0A66C2",
            fillRule: "evenodd",
            clipPath: "url(#LinkedIn_svg__a)",
            clipRule: "evenodd",
            children: [
              /* @__PURE__ */ h("path", { d: "M56.37 6.004H4.49A4.443 4.443 0 0 0 0 10.392v52.093a4.446 4.446 0 0 0 4.492 4.393H56.37a4.455 4.455 0 0 0 4.51-4.393V10.388A4.452 4.452 0 0 0 56.37 6v.004Zm-4.498 51.869h-9.02V43.745c0-3.369-.06-7.705-4.692-7.705-4.698 0-5.417 3.67-5.417 7.46v14.37h-9.02v-29.05h8.66v3.97h.12a9.49 9.49 0 0 1 8.544-4.692c9.143 0 10.829 6.013 10.829 13.837l-.004 15.937ZM13.544 24.85a5.235 5.235 0 1 1-.002-10.47 5.235 5.235 0 0 1 .002 10.47Zm4.51 33.023h-9.03V28.82h9.03v29.052ZM68.466 63.421a1.128 1.128 0 0 0 1.137-1.192c0-.846-.51-1.25-1.557-1.25h-1.69v4.428h.635v-1.93h.782l.018.023 1.213 1.907h.68l-1.305-1.974.087-.012Zm-.739-.443h-.734V61.48h.935c.483 0 1.034.079 1.034.711 0 .727-.558.786-1.235.786Z" }),
              /* @__PURE__ */ h("path", { d: "M64.891 60.244a4.151 4.151 0 0 1 2.917-1.237h.08a4.151 4.151 0 1 1-2.997 1.237Zm.884 6.01a3.64 3.64 0 0 0 2.033.58v-.002h.095a3.562 3.562 0 0 0 3.484-3.637v-.061a3.64 3.64 0 1 0-5.612 3.12Z" })
            ]
          }
        ),
        /* @__PURE__ */ h("defs", { children: /* @__PURE__ */ h("clipPath", { id: "LinkedIn_svg__a", children: /* @__PURE__ */ h(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h72v72H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  m as LinkedIn
};
